export default "/images/vendor/flag-icon-css/flags/1x1/ca.svg?102b45b24a03abdaeae6cf78eb470b12";